// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { floorsRequested, floorsRequestFailed, floorsRequestSucceeded } from './dashboard-floors.actions';
import { of } from 'rxjs';
import { DashboardFloorsService } from '../services/dashboard-floors.service';

@Injectable()
export class DashboardFloorsEffects {

  floorsRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(floorsRequested),
      mergeMap((action) => this.floorsService.floors(action.clientId, action.timePeriod, action.page, action.categoryId).pipe(
        map((floorsResponse) => floorsRequestSucceeded({floorsResponse})),
        catchError(() => of(floorsRequestFailed())),
      )),
    ),
  );

  constructor(private actions$: Actions,
              private store$: Store,
              private floorsService: DashboardFloorsService) {
  }
}
